import './QuestionItem.less';
export { default } from './QuestionItem.js';